import {DownloadStateType} from './types';
import {DefaultDownloadState} from './constants';
import {RequestsStatus} from '../../actions/actionsTypes';

export default (state = DefaultDownloadState, action: any): DownloadStateType => {
    switch (action.type) {
        default:
            return state;
    }
}